import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  ogImage?: string;
  ogType?: string;
  canonical?: string;
}

export default function SEO({
  title,
  description,
  keywords = "software development,Web Design, web development, mobile app development, UAE, Dubai, Abu Dhabi, Sharjah, custom software, enterprise solutions, startup development",
  ogImage = "https://res.cloudinary.com/due4nhetn/image/upload/v1698754323/firstsoftuae-hero-image.png",
  ogType = "website",
  canonical
}: SEOProps) {
  const fullTitle = title.includes("First Soft UAE") ? title : `${title} | First Soft UAE`;
  const url = canonical || (typeof window !== 'undefined' ? window.location.href : 'https://firstsoft.ae');

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "First Soft UAE",
    "description": "Professional web design and development services",
    "url": "https://firstsoft.ae",
    "logo": "https://firstsoft.ae/logo.png",
    "image": "https://firstsoft.ae/firstsoftuae-image.webp",
    "telephone": "+971-58-248-1443",
    "priceRange": "$5000",
    "sameAs": [
      "https://www.facebook.com/firstsoftuae/",
      "https://www.linkedin.com/company/firstsoftuae"
    ],
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Almawarid Building, Industrial Area 3",
      "addressLocality": "Dubai",
      "addressRegion": "UAE",
      "postalCode": "00000",
      "addressCountry": "AE"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Web Design Services",
      "itemListElement": [
        {
          "@type": "OfferCatalog",
          "name": "Web Design",
          "url": "https://firstsoft.ae/web-design-development"
        }
      ]
    }
  };

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} data-react-helmet="true" />
      <meta name="keywords" content={keywords} data-react-helmet="true" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} data-react-helmet="true" />
      <meta property="og:url" content={url} data-react-helmet="true" />
      <meta property="og:title" content={fullTitle} data-react-helmet="true" />
      <meta property="og:description" content={description} data-react-helmet="true" />
      <meta property="og:image" content={ogImage} data-react-helmet="true" />
      <meta property="og:site_name" content="First Soft UAE" data-react-helmet="true" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" data-react-helmet="true" />
      <meta property="twitter:url" content={url} data-react-helmet="true" />
      <meta property="twitter:title" content={fullTitle} data-react-helmet="true" />
      <meta property="twitter:description" content={description} data-react-helmet="true" />
      <meta property="twitter:image" content={ogImage} data-react-helmet="true" />
      
      {/* Additional SEO tags */}
      <meta name="robots" content="index, follow" data-react-helmet="true" />
      <meta name="author" content="First Soft UAE" data-react-helmet="true" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" data-react-helmet="true" />
      <link rel="canonical" href={url} data-react-helmet="true" />
      
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};
